Vue.component("MpModuleCookies", {
    props: {
        title: String,
        pFirst: String,
        pSecond: String,
        acceptLabel: String,
        viewLabel: String,
        viewLink: String,
    },
    mixins: [MpCookieConsent],
    data: function() {
        return {
            cookiesAccepted: true,
            isClosed: false,
        };
    },

    computed: {},

    methods: {

        close: function() {
            this.isClosed = true;
        },

        init: function() {
            this.updateStatus();
            this.updateTypeStatus();

            if (!this.cookiesAccepted) {
                CookieManager.statsView(CookieManager.VIEW_TOAST);
            }

            this.updateIframes();
            MpEventBus.$on(EVENT_COOKIE_CONSENT_HIDE, this.updateStatus);
        },

        acceptAll: function() {
            CookieManager.setCookie(CookieManager.CONSENT, COOKIE_VERSION, 10*365, '/');
            CookieManager.setCookie('mp_chkcookie_'+CookieManager.TYPE_ANALYTICS, true, 10*365, '/');
            CookieManager.setCookie('mp_chkcookie_'+CookieManager.TYPE_MARKETING, true, 10*365, '/');

            this.cookiesAccepted = true;
            CookieManager.statsAction(CookieManager.ACTION_ACCEPT);

            if (typeof(GTMManager) !== 'undefined' && !GTMManager.getInstance().isLoaded()) {
                GTMManager.getInstance().loadGTM();
            }

            this.updateIframes();
            this.close();
        },

        showCookiesConsent: function() {
            MpEventBus.$emit(EVENT_COOKIE_CONSENT_SHOW);
        },
    },

    mounted: function() {
        this.init();
    },

    destroyed: function() {
        MpEventBus.$off(EVENT_COOKIE_CONSENT_HIDE, this.updateStatus);
    },

    template: '\
    <div class="float-box-container float-box-container--large float-box-container--scrollable" v-if="!cookiesAccepted && !isClosed">\
        <div class="float-box float-box--cookies">\
            <a class="float-box__close close-btn" href="#" @click.prevent="close()">\
                <svg width="12" height="12" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M4 8l4-4 8 8 8-8 4 4-8 8 8 8-4 4-8-8-8 8-4-4 8-8z"/></svg>\
            </a>\
            <h2 class="float-box__title">{{title}}</h2>\
            <div class="float-box__content">\
                <slot name="content"></slot>\
            </div>\
            <div class="float-box__actions row row--extended align-items-center">\
                <div class="float-box__action col-12 col-sm-auto">\
                    <a class="btn-ghost btn-ghost--center btn-ghost--mobile-full btn-ghost--text" :href="viewLink" @click.prevent="showCookiesConsent()">{{viewLabel}}</a>\
                </div>\
                <div class="float-box__action col-12 col-sm-auto">\
                    <a class="btn btn--center btn--mobile-full" href="#" @click.prevent="acceptAll()">{{acceptLabel}}</a>\
                </div>\
            </div>\
        </div>\
    </div>',
});